import React, { createContext, useContext, useState } from "react";
import { ICheckboxTermosUsoPIE, IErrorMessageLogin, IErrorMessagePassword, LoginContextProps, LoginForm } from "models/login";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { ResetPasswordProvider } from "./reset-password-context";

const LoginContext = createContext({} as LoginContextProps);

function LoginProvider({ children }) {
  const [canCheckLogin, setCanCheckLogin] = useState<boolean>(false);
  const [checkboxTerms, setCheckboxTerms] = useState<ICheckboxTermosUsoPIE>({
    showCheckbox: false,
    isChecked: false,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loginData, setLoginData] = useState<LoginForm>({
    email: '',
    password: '',
  });
  const [redirectURL, setRedirectURL] = useState<string>('');
  const [showTermsUse, setShowTermsUse] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<IErrorMessageLogin | IErrorMessagePassword | ''>('');

  const reCaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

  const keys = [
    'tokenIES',
    'refreshToken',
    'usuarioIES',
    'NPSemailIES',
    'NPSnomeIES',
  ];

  const redirectToLogin = (event?) => {
    event && event.preventDefault();
    setCheckboxTerms({
      ...checkboxTerms,
      showCheckbox: true,
    });
    setShowTermsUse(false);
    setIsLoading(false);
    setErrorMessage('');

    keys.forEach((key) => localStorage.removeItem(key));
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
      <LoginContext.Provider
        value={{
          canCheckLogin,
          checkboxTerms,
          isLoading,
          loginData,
          redirectURL,
          showTermsUse,
          errorMessage,
          setCanCheckLogin,
          setCheckboxTerms,
          setIsLoading,
          setLoginData,
          setRedirectURL,
          setShowTermsUse,
          setErrorMessage,
          redirectToLogin,
          keys,
        }}
      >
        <ResetPasswordProvider>
          {children}
        </ResetPasswordProvider>
      </LoginContext.Provider>
    </GoogleReCaptchaProvider>
  );
}

function useLoginContext() {
  return useContext(LoginContext);
}

export { useLoginContext, LoginProvider };